import * as React from 'react';
import { Hr, Text } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const UnpublishedProductEcommContent = ({ productColor  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("section", {
        className: "unpublished-product-ecomm-content"
    }, productColor && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        color: "text-secondary",
        "data-t": "productColor-text",
        className: "unpublished-product-ecomm-content__product-color"
    }, productColor)), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default"
    }, getLabel('products.unpublished.productUnavailable')));
};

export { UnpublishedProductEcommContent };
//# sourceMappingURL=UnpublishedProductEcommContent.js.map
